import { configureStore } from "@reduxjs/toolkit";
import userDetailsReducer from "features/userDetails/userDetailsSlice";
import usersCompanyDetailsReducer from "features/userDetails/companyAccessSlice";
import usersRoleDetailsReducer from "features/userDetails/usersRolesSlice";
import authReducer from "features/auth/authSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userDetailsReducer,
    companyAccess: usersCompanyDetailsReducer,
    roles: usersRoleDetailsReducer,
  },
});
